import { DefaultPeriod, FixedPeriod } from "modules/HRAccount/PeriodsDropdown/PeriodsDropdown"
import { toQueryString } from "modules/HRAccount/utils"
import { httpClient } from "utils/infrastructure/httpClient"

export interface CompanyInfo {
    title: string
    balance: number
    manager: {
        name: string
        email: string
        telegram: string | null
    }
}

export interface GrouppedTherapyRequest {
    month: string
    year: number
    requests: TherapyRequest[]
}

export interface TherapyRequest {
    top_competence: string
    percentage: number
}

export interface AvailablePeriod {
    start_date: number | null
}

export interface MonthReport {
    active_clients: number
    continue_therapy: number
    expenses_sum: number
    new_clients: number
    session_count: number
    session_start_datetime__month: number
    session_start_datetime__year: number
}

export interface Statistic {
    session_count: number
    employees: number
    average_bill: number
    expenses_sum: number
    popular_requests: GrouppedTherapyRequest[]
    session_per_employee: number
    months: MonthReport[]
    forecast: number | null
}

export function getCompanyInfo() {
    return httpClient.get<CompanyInfo>("company/info")
}

export function getAvailablePeriod() {
    return httpClient.get<AvailablePeriod>("company/report/available-period")
}

export function getReport(period: DefaultPeriod | FixedPeriod) {
    return httpClient.get<Statistic>(`company/report${toQueryString(period)}`)
}
